import { render, staticRenderFns } from "./ValidarODMs.vue?vue&type=template&id=4dd06d35&scoped=true"
import script from "./ValidarODMs.vue?vue&type=script&lang=js"
export * from "./ValidarODMs.vue?vue&type=script&lang=js"
import style0 from "./ValidarODMs.vue?vue&type=style&index=0&id=4dd06d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd06d35",
  null
  
)

export default component.exports